import { useSetAtom } from 'jotai';

import * as state from '../../../_state/loadDetail.state';

import { FileMutations } from '~/modules/trade/types/file';

export const useLoadFiles = (): FileMutations => {
  const createLoadPhoto = useSetAtom(state.$createLoadPhoto);
  const confirmLoadPhotoUpload = useSetAtom(state.$confirmLoadPhotoUpload);
  const deleteLoadPhoto = useSetAtom(state.$deleteLoadPhoto);
  const updateLoadPhoto = useSetAtom(state.$updateLoadPhoto);

  return {
    createFile: async (params) => {
      const result = await createLoadPhoto({
        fileName: params.fileName,
        mimeType: params.mimeType,
        loadId: params.entityId,
        fileSize: params.fileSize,
        isPhotoRequirement: params.metadata?.isPhotoRequirement,
      });

      return {
        id: result.tradeLoadPhotoCreate.file.id,
        uploadUrl: result.tradeLoadPhotoCreate.uploadUrl as string,
      };
    },
    confirmUpload: async (params) => {
      const _result = await confirmLoadPhotoUpload({ fileId: params.fileId });

      return {
        url: '', // No download URL available from confirm upload, will use download hook when needed
      };
    },
    deleteFile: async (params) => {
      await deleteLoadPhoto({ fileId: params.fileId });
    },
    updateFileMetadata: async (params) => {
      const result = await updateLoadPhoto({
        fileId: params.fileId,
        notes: params.notes,
        photoRequirementId: params.photoRequirementId ?? undefined,
      });

      return {
        id: result.tradeLoadPhotoUpdate.id,
      };
    },
  };
};
